(function ($) {
  'use strict';

  $(document).ready(function () {
    // Match height of cards in card listing.
    $('.card__content').matchHeight();
  });
})(jQuery);
